import { WarningCircle } from "@phosphor-icons/react";
import { get } from "lodash";
import React, { InputHTMLAttributes } from "react";
import { UseFormRegister, RegisterOptions } from "react-hook-form";

interface IFormItemProps {
  name: string,
  label?: string | React.ReactNode,
  suffix?: string | React.ReactNode,
  startAdornment?: string | React.ReactNode,
  type?: string
  register: UseFormRegister<any>,
  rules?: RegisterOptions,
  errors?: any,
  note?: string,
}

const Input = ({ name, label, suffix, type = "text", register, rules, errors, note, startAdornment, ...inputProps }: IFormItemProps & InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <div className="dv-form__input">
      {label && <label>{label} {rules?.required && <span className="danger-text">*</span>}</label>}
      <div className={`dv-form__input__wrapper ${get(errors, `${name}.message`, '') ? 'dv-form__input__wrapper--error' : ''}`}>
        {startAdornment && <span className="dv-form__input__wrapper__suffix">{startAdornment}</span>}
        <input
          type={type}
          {...register(name, rules)}
          {...inputProps}
          autoComplete="off"
        />
        {suffix && <span className="dv-form__input__wrapper__suffix">{suffix}</span>}
      </div>
      {note && <div className="dv-form__input__wrapper__note">{note}</div>}
      {
        get(errors, `${name}.message`, '') &&
        <div className="danger-text">
          <WarningCircle size={16} />{get(errors, `${name}.message`, '')}
        </div>
      }
    </div>
  )
}

export default Input;
